"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "More options": "Дополнительные настройки",
  "Press enter to explore {overflowItems} more actions.": ["Нажмите Enter, чтобы просмотреть дополнительные действия (", ["overflowItems"], ")."]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map